import { Col, FormLabel, FormSelect, Row } from "react-bootstrap";
import { useState } from "react";
import RollDice from "../dice-rolling";

export default function Tiring() {
    const [crewQuality, setCrewQuality] = useState("ex");
    const [moveRate, setMoveRate] = useState("battle");
    const [tiring, setTiring] = useState("");

    function rollForCrewTiring() {
        const roll: number = RollDice(1)[0];
        let fatigue: string = "";
        if (moveRate === "battle") {
            switch (crewQuality) {
                case "ix":
                    fatigue = roll <= 4 ? "Fatigued" : "Not Fatigued";
                    setTiring(fatigue);
                    break;
                case "ex":
                    fatigue = roll <= 2 ? "Fatigued" : "Not Fatigued";
                    setTiring(fatigue);
                    break;
                case "vt":
                    fatigue = roll === 1 ? "Fatigued" : "Not Fatigued";
                    setTiring(fatigue);
                    break;
            }
        } else if (moveRate === "ram") {
            switch (crewQuality) {
                case "ix":
                    fatigue = roll <= 5 ? "Fatigued" : "Not Fatigued";
                    setTiring(fatigue);
                    break;
                case "ex":
                    fatigue = roll <= 3 ? "Fatigued" : "Not Fatigued";
                    setTiring(fatigue);
                    break;
                case "vt":
                    fatigue = roll <= 2 ? "Fatigued" : "Not Fatigued";
                    setTiring(fatigue);
                    break;
            }
        }
    }

    return (
        <>
            <Row>
                <Col>
                    <h1>Crew Tiring</h1>
                </Col>
            </Row>
            <Row>
                <Col sm={6} className="mt-3">
                    <FormLabel htmlFor="crew-quality">Crew Quality</FormLabel>
                    <FormSelect id="crew-quality" value={crewQuality} onChange={(e) => setCrewQuality(String(e.target.value))}>
                        <option value={"ix"}>Inexperienced Crew</option>
                        <option value={"ex"}>Experienced Crew</option>
                        <option value={"vt"}>Veteran Crew</option>
                    </FormSelect>
                </Col>
                <Col sm={6} className="mt-3">
                    <FormLabel htmlFor="move-rate">Move Rate</FormLabel>
                    <FormSelect id="move-rate" value={moveRate} onChange={(e) => setMoveRate(String(e.target.value))}>
                        <option value={"battle"} selected>Battle</option>
                        <option value={"ram"}>Ram</option>
                    </FormSelect>
                </Col>
            </Row>
            <Row>
                <Col>
                    <button className="btn btn-primary mt-3" onClick={() => rollForCrewTiring()}>Roll for Crew Tiring</button>
                </Col>
            </Row>
            <Row>
                <Col>
                    <h1 className="mt-5">{tiring}</h1>
                </Col>
            </Row>
        </>
    )
}